import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { edit } from "../../store/auth/authSlice";

const SecurityTab = () => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const info = useSelector((state) => state.info);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);

  const validation = yup.object({
    current_password: yup
      .string()
      .required(t("{{field}} is required", { field: "Mevcut Şifre" })),
    password: yup
      .string()
      .required(t("{{field}} is required", { field: t("Password") })),
    repeat_password: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match"),
  });

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: { current_password:"",repeat_password: "", password: "" },
    resolver: yupResolver(validation),
  });

  const onSubmit = (data) => {
    dispatch(edit({ id: user.id, password: data.password,current_password:data.current_password }));
  };

  return (
    <Box>
      <h3 className="text-4xl mb-8">{t("Password and security")}</h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box className="mb-6">
          <div className="mb-4">
            <Controller
              name="current_password"
              control={control}
              render={({ field }) => (
                <TextField
                  className="mt-2"
                  error={typeof errors.password !== "undefined"}
                  size="small"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  placeholder={"Mevcut Şifre"}
                  helperText={errors.current_password && t(errors.current_password.message)}
                  {...field}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          onMouseDown={(e) => {
                            e.preventDefault();
                          }}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </div>
          <div className="mb-4">
            <Controller
              name="password"
              control={control}
              render={({ field }) => (
                <TextField
                  className="mt-2"
                  error={typeof errors.password !== "undefined"}
                  size="small"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  placeholder={"Yeni Şifre"}
                  helperText={errors.password && t(errors.password.message)}
                  {...field}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          onMouseDown={(e) => {
                            e.preventDefault();
                          }}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </div>
          <div className="mb-4">
            <Controller
              name="repeat_password"
              control={control}
              render={({ field }) => (
                <TextField
                  className="mt-2"
                  error={typeof errors.repeat_password !== "undefined"}
                  size="small"
                  type={showPasswordRepeat ? "text" : "password"}
                  fullWidth
                  placeholder={"Yeni Şifre Tekrarı"}
                  helperText={
                    errors.repeat_password && t(errors.repeat_password.message)
                  }
                  {...field}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            setShowPasswordRepeat(!showPasswordRepeat);
                          }}
                          onMouseDown={(e) => {
                            e.preventDefault();
                          }}
                          edge="end"
                        >
                          {showPasswordRepeat ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </div>
        </Box>
        <Box className="flex justify-end">
          <Button
            type="submit"
            variant="contained"
            className="rounded px-6"
            disabled={info.loading?.edit}
            startIcon={info.loading?.edit && <CircularProgress size={"1rem"} />}
          >
            {t("Save Changes")}
          </Button>
        </Box>
      </form>
    </Box>
  );
};
export default SecurityTab;
